// features/auth/services/auth.service.ts
import { loginApi } from "../../../api/auth.api";
import type { LoginResponse } from "../../../types/index";

export const loginService = async (
  username: string,
  password: string,
): Promise<LoginResponse> => {
  const res: LoginResponse = await loginApi({ username, password });

  if (!res?.success) {
    throw new Error(res?.message || "ورود ناموفق بود");
  }

  return res;
};
